import { Avatar } from "@material-ui/core";
import { Box, Link, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import isoCountries from "i18n-iso-countries";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { REACT_CREATE_USER } from "../../actions/EndPoints";
import "../../App.css";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import {
  getUserById,
  getUserList,
  resendUserActivationLink,
} from "../../slices/User/UserSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import EmployeeDeleteIcon from "../Employee/EmployeeDeleteIcon";
import ResendIcon from "../Invitations/ResendIcon";
import EditIcon from "../Person/EditIcon";
import DeleteUser from "./DeleteUser";
import UserFilter from "./UserFilter";

export default function User() {
  const history = useHistory();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [clear, setClear] = React.useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [searchedRows, setSerchedRows] = useState([]);
  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [userId, setUserId] = useState();
  const [user, setUser] = useState();
  const [name, setName] = useState();
  const [del, setDel] = useState(false);
  const [openEditUser, setOpenEditUser] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [country, setCountry] = useState("");
  const { darkMode } = useContext(ThemeContext);
  const handleOpen = () => {
    setOpen(true);
    history.push({
      pathname: REACT_CREATE_USER,
      country: country,
    });
  };

  const [filter, setFilter] = React.useState({
    status: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const defaultFilter = {
    status: "",
  };

  const applyFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      status: data.status,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const handleEditUser = (params) => {
    setOpenEditUser(true);
    dispatch(getUserById(params.row.id))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0033") {
          let userData = {
            user: data.data,
            roleName: params.row.roleName,
          };
          setEditRowData(userData);
          history.push({
            pathname: REACT_CREATE_USER,
            state: userData,
            country: country,
          });
        }
      });
  };

  const handleResendAccountActivate = (paramValue) => {
    dispatch(resendUserActivationLink(paramValue))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0001") {
          Toast(t("USERSUCCESS"), "success");
        }
      })
      .catch((er) => { });
  };

  const handleDeleteUser = (params) => {
    setOpenDeleteUser(true);
    setUserId(params.row.id);
    setName(params.row.name);
    setUser(params.row);
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadUserData(filter, paging);
  }, [filter, paging]);

  const loadUserData = (filter, paging) => {
    dispatch(getUserList(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && !CommonUtil.isEmpty(data.data)) {
          setRows(data.data.users);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      });
  };

  const getStatus = (params) => {
    return params.row.status === "Active" ? true : false;
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { name, lastName, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${name?.charAt(0) || ""}${lastName?.charAt(0) || ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(() => [
    {
      field: "user.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },
    {
      field: "name",
      headerName: t("CUSTDATABLE26"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "email",
      headerName: t("CUSTDATABLE02"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.email,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "mobile",
      headerName: t("CUSTDATABLE03"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.phone,
    },

    {
      field: "role",
      headerName: t("USERROLE"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.roleName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "status",
      headerName: t("CUSTDATABLE07"),
      flex: 1,
      valueGetter: (params) =>
        params.row.status === "Active" ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "Actions",
      headerName: t("CUSTDATABLE16"),
      type: "actions",
      flex: 1,
      minWidth: 150,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => handleEditUser(params)}
        />,

        <GridActionsCellItem
          icon={<EmployeeDeleteIcon />}
          label="Delete"
          onClick={() => handleDeleteUser(params)}
        />,
        <GridActionsCellItem
          icon={<ResendIcon toolTip={getStatus(params)} />}
          label="Resend Mail"
          disabled={getStatus(params)}
          onClick={() => handleResendAccountActivate(params.row)}
        />,
      ],
    },
  ]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar title={t("LABELNAVITEMSUSER")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          <UserFilter
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>

        <Tooltip title={t("ADDCUSTOMER")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>

        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
      </Box>

      <div style={{ width: "100%", height: 300 }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          pageCount={totalPages}
          count={totalRecords}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openDeleteUser && (
        <DeleteUser
          open={openDeleteUser}
          handleClose={(data) => {
            setOpenDeleteUser(data);
            loadUserData(filter, paging);
          }}
          DeleteId={userId}
          DeleteName={name}
          user={user}
          delete={() => setDel(true)}
        />
      )}
    </>
  );
}
